<template>
<v-card>
        <v-toolbar
           dense flat
  style="border-bottom: solid #999 1px;border-radius: 0;"
          color="#eee"
        >
       
          <v-toolbar-title>   امتیازات</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
             <v-btn
            icon
            
            @click="$store.state.scores = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </v-toolbar-items>
        </v-toolbar>
<v-container>
<v-row>
<v-col>
         <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-right">
            عنوان
          </th>
          <th class="text-right">
            امتیاز
          </th>
        
        

        </tr>
      </thead>
      <tbody>
        <tr>  <td>اشتراک فعال</td> <td>{{ transactions.plan }}</td>  </tr>
        <tr>  <td>تصویر مدرک فنی حرفه ای</td> <td>{{ transactions.evidence_image }}</td>  </tr>
        <tr>  <td>تولید محتوا</td> <td>{{ transactions.plan }}</td>  </tr>
        <tr>  <td>گزارش تعمیرات</td> <td>{{ transactions.plan }}</td>  </tr>
  
      </tbody>
    </template>
  </v-simple-table>
</v-col>
</v-row>
</v-container>
      </v-card>
</template>
<script>
  export default {
    data: () => ({
      transactions : []
    }),
 mounted(){

     var senddata = {  data: {  data: ['select', 'agent_scores', '*',{agent_brand_id:this.$store.state.user_branding.id}] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
console.log(data)
this.transactions = data.data[0]
     })

 },
  methods: {
  }
  }
</script>